import 'css-chunksrc/client/scenes/constraintEdition/constrainedElement/styles.scss';export default {
  "constrainedElement": "_constrainedElement_83vl3_1",
  "dateType": "_dateType_83vl3_14",
  "element": "_element_83vl3_20",
  "name": "_name_83vl3_25",
  "date": "_date_83vl3_14",
  "footer": "_footer_83vl3_35"
};